module.exports = __webpack_public_path__ + "img/warning-all-dark.5b9f5120.svg";